import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { LoggerService } from 'app/logger/logger.service';


@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  public is_processing: boolean ;
    constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
      private authService: AuthService, private router: Router,private logger:LoggerService, private localStorageService: LocalStorageService) {
    this.sharedService.setHeaderTitle('redirect');
    if (this.localStorageService.get('enrolling') != null) {
      this.is_processing = true;
      let methodName = this.constructor.name+'.verifyToken';
      if (this.localStorageService.get('token') != null) {
          this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
          .then(res => {
            let logObj = {
              method: methodName,
              request: "token : [masked]",
              response: res
            };
            this.logger.logInfo(JSON.stringify(logObj));
              if (res.status === 'success'  && res.isTerminated === false) {
                  const person = res.results[0]['personal'];

                  var dataLayerEvent = 'enroll - processing';
                  (window as any).dataLayer.push({'event': dataLayerEvent, 'accountID': person[0].id.toString()});
                  const that = this;
                  this.enrollForReward(person[0]);
                  this.sharedService.setHeaderTitle('redirect');
                  this.localStorageService.remove('enrolling');
                  setTimeout(function(){
                    that.is_processing = false ;
                    that.sharedService.setHeaderTitle('default');
                    that.router.navigate(['./congrats']);
                  }, 15000);
              }else {
                this.localStorageService.remove('token');
                this.localStorageService.remove('tempToken');
                this.router.navigate(['./enroll']);
              }
            }, (error)=>{
              let logObj = {
                method: methodName,
                request: "token : [masked]",
                exception: error
              };
              this.logger.logError(JSON.stringify(logObj));
            }).catch((ex)=>{
              let logObj = {
                method: methodName,
                request: "token : [masked]",
                exception: ex
              };
              this.logger.logError(JSON.stringify(logObj));
            });

        }else {
            this.router.navigate(['./enroll']);
          }
    }else {
      this.router.navigate(['./dashboard']);
    }
  }

  enrollForReward(person:any){
    this.sharedService.getUserConfig('reward_amount')
      .then(res=>{
        if (res !== undefined && res.result.status === "success") {
          let conf_data = res.result.config[0];
          this.sharedService.enrollToRewardProgram(person, conf_data.value)
            .then(res=>{
              if (res != undefined && res.result == "success") {
                this.sharedService.setRewardToken(res.token);
              }
            });
        }
      });
  }

  payNow() {
     this.router.navigate(['./make-payment']);
    }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/redirect/redirect.component.ts